// extracted by mini-css-extract-plugin
module.exports = {"emptyBag":"EmptyCart_emptyBag__3qgoU","inMenu":"EmptyCart_inMenu__2mHHh","inLayout":"EmptyCart_inLayout__2JRTx","bagImage":"EmptyCart_bagImage__2Rg15"};